<template>
  <el-card>
    <div slot="header" class="page-title">
      <div class="page-hedaer">
        <h4 class="page-title">用户信息</h4>
        <span class="title-info">(重要的事情说三遍：请设置好支付宝信息)</span>
      </div>
    </div>
    <div v-loading="loading" class="profile-content">
      <div class="avatar-section">
        <!-- <el-avatar :size="80" :src="userInfo.avatar_url"></el-avatar> -->
        <div class="user-avatar">
            <img src="/images/user.png" alt="">
          </div>
      </div>
      <el-descriptions>
        <el-descriptions-item label="账号">
          {{ userInfo.phone }}
        </el-descriptions-item>
        <el-descriptions-item label="角色">
          <el-tag size="small">{{getRoleText(userInfo.role)}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="邀请码" v-if="userInfo.invite_code">
          <div class="invite-code">
            <span>{{ userInfo.invite_code }}</span>
            <el-button type="primary" size="mini" @click="copyInviteCode"
              >复制邀请信息</el-button
            >
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="支付宝信息">
          <div class="invite-code">
            <span v-if="alipayAccount"
              >{{ alipayName }}({{ alipayAccount }})</span
            >
            <span v-else style="color:#F56C6C">未设置</span>
            <el-button
              type="primary"
              size="small"
              @click="openAlipayDialog"
              style="margin-left: 10px"
              >{{alipayAccount?'修改':'设置'}}</el-button
            >
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 操作按钮 -->
      <el-divider></el-divider>
      <div class="action-list">
        <el-button type="primary" @click="logout">退出登录</el-button>
        <el-button type="danger" @click="openPasswordDialog">修改密码</el-button>
      </div>
    </div>

    <!-- 支付宝信息弹窗 -->
    <el-dialog
      title="支付宝信息"
      :visible.sync="alipayDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="alipayForm" label-width="120px">
        <el-form-item label="支付宝账号">
          <el-input
            v-model="alipayForm.alipay_account"
            placeholder="请输入支付宝账号"
          />
        </el-form-item>
        <el-form-item label="支付宝姓名">
          <el-input
            v-model="alipayForm.alipay_name"
            placeholder="请输入支付宝姓名"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="alipayDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAlipayInfo" :loading="alipayLoading">保存</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="passwordForm"
        :rules="passwordRules"
        ref="passwordFormRef"
        label-width="80px"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="changePassword" :loading="passwordLoading">确认修改</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import api from "../../api";
import { encryptPassword } from "../../utils/crypto";

export default {
  name: "Profile",
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      userInfo: {
        phone: "",
        invite_code: "",
        role:'',
      },
      alipayAccount: "",
      alipayName: "",
      
      // 支付宝弹窗
      alipayDialogVisible: false,
      alipayLoading: false,
      alipayForm: {
        alipay_account: "",
        alipay_name: ""
      },
      
      // 密码弹窗
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { min: 6, message: "密码长度至少6位", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度至少6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.fetchUserInfo();
  },
  methods: {
    getRoleText(name) {
      const textMap = {
        user: "普通用户",
        leader: "金牌团长",
        admin: "管理员",
      };
      return textMap[name] || "--";
    },
    async fetchUserInfo() {
      this.loading = true;
      try {
        const { data } = await api.get("/api/users/me");
        this.userInfo = data;
        this.alipayAccount = data.alipay_account || "";
        this.alipayName = data.alipay_name || "";
      } catch (e) {
        this.$message.error(e?.userMessage || "获取用户信息失败");
      } finally {
        this.loading = false;
      }
    },
    copyInviteCode() {
      const textarea = document.createElement("textarea");
      const content = `抖音直播间购物享折扣，你来买，我补贴\n化妆品，数码，母婴、日货大牌商品6折起\n手机端网址：https://m.baofu.me\n电脑端网址：https://pc.baofu.me\n注册邀请码：${this.userInfo.invite_code}`;
      textarea.value = content;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("邀请信息复制成功");
      } catch (e) {
        this.$message.error("复制失败");
      }
      document.body.removeChild(textarea);
    },
    openAlipayDialog() {
      this.alipayForm = {
        alipay_account: this.alipayAccount,
        alipay_name: this.alipayName
      };
      this.alipayDialogVisible = true;
    },
    async saveAlipayInfo() {
      if (!this.alipayForm.alipay_account || !this.alipayForm.alipay_name) {
        this.$message.warning("请填写完整的支付宝信息");
        return;
      }
      
      this.alipayLoading = true;
      try {
        await api.put("/api/users/alipay", {
          alipay_account: this.alipayForm.alipay_account,
          alipay_name: this.alipayForm.alipay_name,
        });
        this.alipayAccount = this.alipayForm.alipay_account;
        this.alipayName = this.alipayForm.alipay_name;
        this.alipayDialogVisible = false;
        this.$message.success("支付宝信息保存成功");
      } catch (e) {
        this.$message.error(e?.userMessage || "保存支付宝信息失败");
      } finally {
        this.alipayLoading = false;
      }
    },
    openPasswordDialog() {
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.$nextTick(() => {
        this.$refs.passwordFormRef?.resetFields();
      });
      this.passwordDialogVisible = true;
    },
    async changePassword() {
      try {
        await this.$refs.passwordFormRef.validate();
      } catch (e) {
        return;
      }

      this.passwordLoading = true;
      try {
        const encryptedOld = await encryptPassword(
          this.passwordForm.oldPassword
        );
        const encryptedNew = await encryptPassword(
          this.passwordForm.newPassword
        );

        await api.put("/api/users/password", {
          old_password: encryptedOld,
          new_password: encryptedNew,
        });

        this.$message.success("密码修改成功");
        this.passwordDialogVisible = false;
        this.passwordForm = {
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        };
      } catch (e) {
        this.$message.error(e?.userMessage || "密码修改失败");
      } finally {
        this.passwordLoading = false;
      }
    },
    logout() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_role");
      this.$router.replace("/login");
    }
  },
};
</script>

<style scoped>
.page-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-hedaer{
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title{
  margin: 0;
}
.title-info{
  margin-left: 5px;
  font-size: 12px;
  color:#909399;
}
.profile-content {
  padding: 20px 0;
}
.profile-content >>> .el-descriptions-item__container {
  align-items: center;
}
.avatar-section {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.action-list {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}
.invite-code {
  display: flex;
  align-items: center;
  gap: 10px;
}
.user-avatar{
  width: 80px;
  height: 80px;
  background: #eee;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-avatar img{
  width: 48px;
  height: 48x;
}
</style>
